import Game from "./scenes/Game/Game.js";

export default {
    fonts: {fulbotano: "fulbotano"}, //You can add web fonts that you generated via fontSquirrel here. (https://www.fontsquirrel.com/tools/webfont-generator)
    
    scenes: [Game],
    startScene: Game.KEY,

    spines: [], //Place the name of the spine file here, excluding the extension
    isDev: false
}
